import { Text } from '@chakra-ui/react/text';

const CustomTickY = ({ y, payload, formatter, orientation, className, width }: any) => {
  return (
    <foreignObject x={0} y={y - 10} className={className} width={width} height="1.5em">
      <Text
        textAlign={orientation === 'right' ? 'left' : 'right'}
        textStyle="body/md/regular"
        color="text/tertiary"
        paddingRight="12"
        whiteSpace="nowrap"
      >
        {formatter ? formatter(payload.value) : payload.value}
      </Text>
    </foreignObject>
  );
};

export default CustomTickY;
